
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M21.672 1.736a5.516 5.516 0 011.284 1.895 5.735 5.735 0 010 4.306 5.516 5.516 0 01-1.284 1.895l-9.192 8.942c-.576.564-1.284 1.035-2.124 1.412a7.72 7.72 0 01-2.664.659c-.936.062-1.892-.063-2.868-.377s-1.88-.878-2.712-1.694c-.816-.8-1.384-1.667-1.704-2.6a7.032 7.032 0 01-.384-2.79 7.407 7.407 0 01.66-2.611c.376-.816.852-1.506 1.428-2.071l8.16-7.93c.144-.142.356-.177.636-.106.28.07.492.176.636.317.128.142.232.35.312.624.08.275.048.482-.096.624l-8.136 7.906a5.657 5.657 0 00-1.08 1.483 4.648 4.648 0 00-.216 3.765c.24.659.672 1.294 1.296 1.906.56.55 1.18.938 1.86 1.165a5.36 5.36 0 002.028.282 5.895 5.895 0 001.92-.435 4.833 4.833 0 001.56-1.012l9.168-8.918c.432-.424.74-.863.924-1.318.184-.455.272-.906.264-1.353a3.058 3.058 0 00-.324-1.306 4.305 4.305 0 00-.864-1.177c-.688-.659-1.46-.969-2.316-.93-.856.04-1.716.483-2.58 1.33l-8.28 8.072c-.368.36-.548.76-.54 1.2.008.439.156.8.444 1.082.352.345.756.486 1.212.424.456-.063.828-.236 1.116-.518l7.512-7.318c.144-.142.356-.177.636-.106.28.07.492.176.636.317.144.142.256.35.336.624.08.274.048.482-.096.624l-7.536 7.318c-.576.565-1.128.957-1.656 1.177-.528.22-1.024.317-1.488.294a2.969 2.969 0 01-1.296-.365c-.4-.22-.768-.486-1.104-.8a3.78 3.78 0 01-.732-.965 3.082 3.082 0 01-.372-1.294c-.032-.47.052-.973.252-1.506.2-.534.588-1.075 1.164-1.624.288-.282.544-.541.768-.776.192-.204.372-.385.54-.542l.276-.259 6.696-6.541a6.899 6.899 0 011.884-1.33 5.717 5.717 0 012.076-.553 5.222 5.222 0 012.076.282c.68.236 1.308.636 1.884 1.2z","fill":"#fff"}})])
          )
        }
      }
    